import { frontendURL } from 'dashboard/helper/URLHelper';

const OnboardingIndex = () => import('./pages/OnboardingIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_index',
      component: OnboardingIndex,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
